import React from "react";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { media } from "utils/style";
import Button from "common-components/Buttons";

import Modal from "common-components/Modal/Modal";


const DeleteHumModal = ({ modalContent, dateOfRequest,closeModal, ...props }) => (
  <Modal visibleModal closeModal={closeModal} contentLabel="pending request modal">
    <Container>
      <H2>{convertStringToElements(modalContent.section_title)}</H2>
      <Div>
      {convertStringToElements(modalContent.section_description)}
       </Div>
      <div style={{ marginTop: "32px" }}>
        <Button type="button" onClick={closeModal} background={"black"}>
          {modalContent.buttons[0].text}
        </Button>
      </div>
    </Container>
  </Modal>
);

export default DeleteHumModal;

const Container = styled.div`
  max-width: 450px;
  padding-right: 48px;

  ${media.mobile`
    padding-right: 0;
  `}
`;

const Div = styled.div`
  p {
    margin-top:10px;
    color: #000;
    font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.5px;
  }
`;

const H2 = styled.h2`
   font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
   font-size: 32px;
   font-style: normal;
   font-weight: 400; 
   line-height: 36px;
   margin-bottom: 15px;
`;

